import { ampli } from '~entities/ampli';

import { Screen, ScreenHeader } from '~shared/ui/screen';

import { Button } from '@breezeventures/ui-kit/button';
import { Typography } from '@breezeventures/ui-kit/typography';

import RunningManIcon from './icons/running-man.svg?react';

type ContinueAirtableProps = {
  onBack: () => void;
  onClose: () => void;
};

const AIRTABLE_LINK =
  'https://airtable.com/appyMyt4DnrwLc2bY/pagUurLvIaiJdIpen/form';

export const ContinueAirtable = ({
  onBack,
  onClose,
}: ContinueAirtableProps) => {
  const handleGoToAirtable = () => {
    ampli.mpPaAirtableScreenOpenClick();
    window.open(AIRTABLE_LINK, '_blank');
  };

  return (
    <Screen header={<ScreenHeader onBack={onBack} onClose={onClose} />}>
      <div className="my-auto flex flex-col items-center">
        <RunningManIcon />

        <div className="my-8 flex flex-col items-center gap-6">
          <Typography.Title size="s" className="text-center">
            Continue filling out your application with Airtable
          </Typography.Title>

          <Button
            type="button"
            size="l"
            variant="primary"
            onClick={handleGoToAirtable}
          >
            Go to Airtable
          </Button>
        </div>
      </div>
    </Screen>
  );
};
